import { combineReducers } from 'redux';

import autoCompleteReducer from './reducers/AutoComplete.reducer';
import emptySearchReducer from './reducers/EmptySearch.reducer';
import suggestionsReducer from './reducers/Suggestions.reducer';

export default combineReducers({
  suggestions: suggestionsReducer,
  autoComplete: autoCompleteReducer,
  emptySearch: emptySearchReducer,
});
